import React, { PureComponent } from 'react';
import SolvTabs from '../../../../SolvPatternLibrary/Tabs';
import Loading from '../../../../SolvPatternLibrary/Loading';
import Collapse from '@material-ui/core/Collapse';
import ClinicClosed from './ClinicClosed';
import { fetchSlotsForDate } from './fetchSlots';
import NoSlotsLeft from './NoSlotsLeft';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { dateHasOpenHours } from '../../../../../core/util/location';
import ReducedTimeSlotGrid from './components/ReducedTimeSlotGrid';
import {
  generateSlotsFromOperatingHours,
  getSlotsForTodayAndTomorrow,
  isReservationsRemaining,
  isSlotAvailable,
  removeSlotsBeforeDisableReservationsUntilTimestamp,
} from '../../../../../core/location/slots';
import { colors } from '../../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../../constants/text';
import DateTime from '../../../../DateTime';
import SlotShape from '../../../../../shapes/Slot';
import Tabs from '@material-ui/core/Tabs';
import { isDateAfterTomorrow, isDateToday, isDateTomorrow } from '../../../../../core/util/date';
import { hasSlotsAvailable } from '../../../../../core/location/slots';
import SolvCalendar from '../../../../SolvPatternLibrary/Calendar';
import { MORE_DATES_SLOT_SELECTOR, shouldShowFeature } from '../../../util/customization';
import { analyticsTrackEvent } from '../../../../../core/analytics';
import { CLICK_MORE_DATES } from '../../../../../core/analytics/events';
import { EMPTY_ARRAY, isEmptyArray } from '../../../../../core/util/array';

const TODAY = 'today';
const TOMORROW = 'tomorrow';
const MORE_DATES = 'more dates';

const SpacedLoading = styled.div`
  text-align: center;
  height: 255px;
  align-items: center;
  justify-content: center;
  display: flex;
`;

const SlotLoading = styled(SpacedLoading)`
  height: 117px;
`;

const Content = styled.div`
  padding-top: 24px;
  border-top: 1px solid #eaeae8;
  width: 90%;
  margin: 0 auto 15px;
`;

const StyledTabs = styled(SolvTabs)`
  width: 90%;
  margin: 0 5%;
  background-color: ${colors.white};
  & span {
    height: 2px;
    font-family: ${fontFamily.medium};
  }
  & button {
    text-align: center;
    width: ${({ length }) => Math.round(100 / length)}%;
    font-size: ${fontSize.small};
    min-width: unset;
    white-space: nowrap;
  }
`;

const StyledTimeSlotGrid = styled(ReducedTimeSlotGrid)`
  justify-content: center;
`;

const Day = styled.div`
  color: ${colors.myRightFoot};
  font-size: ${fontSize.medium};
  letter-spacing: -0.18px;
  line-height: 18px;
  text-align: center;
  font-family: ${fontFamily.bold};
  margin-bottom: 16px;
`;

const PlainTabs = styled(Tabs)``;

export const popFirstUnavailableSlots = slots => {
  for (let i = 0; i < slots.length; i++) {
    if (slots[i].availability !== 0) {
      return slots.slice(i);
    }
  }

  return [];
};

class TimeSelector extends PureComponent {
  constructor(props) {
    super(props);
    this.tabs = [
      {
        label: TODAY.toUpperCase(),
        onClick: () =>
          this.setAndHandleDate({
            selectedDate: moment.tz(this.props.location.timeZone),
            nextDate: moment.tz(this.props.location.timeZone).add(1, 'day'),
            isMoreDate: false,
          }),
      },
      {
        label: TOMORROW.toUpperCase(),
        onClick: () =>
          this.setAndHandleDate({
            selectedDate: moment.tz(this.props.location.timeZone).add(1, 'day'),
            nextDate: moment.tz(this.props.location.timeZone).add(2, 'day'),
            isMoreDate: false,
          }),
      },
    ];

    if (shouldShowFeature(MORE_DATES_SLOT_SELECTOR, props.location))
      this.tabs.push({
        label: MORE_DATES.toUpperCase(),
        onClick: () => {
          this.setState({
            isMoreDate: true,
          });
          analyticsTrackEvent(CLICK_MORE_DATES, {
            isSRP: window.location.pathname === '/search',
            isCDP: !window.location.pathname === '/search',
          });
        },
      });
  }

  state = {
    selectedDate: null,
    nextDate: null,
    isMoreDate: false,
    futureSlotData: {},
  };

  componentDidMount() {
    if (!this.props.location.hasOwnProperty('slots')) {
      this.props.fetchLocationSlotsData(this.props.location.id);
    } else {
      this.updateSelectedAndNextDates();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.validateSelectedSlots();

    const { futureSlotData, isMoreDate, nextDate, selectedDate } = this.state;

    const shouldUpdateState =
      this.props.location.hasOwnProperty('slots') && !selectedDate && !nextDate;
    if (shouldUpdateState) {
      this.updateSelectedAndNextDates();
    }

    if (isMoreDate && !(selectedDate.format('YYYY-MM-DD') in futureSlotData)) {
      this.fetchSlotDataForDate(selectedDate);
    }
  }

  getContentToRender = () => {
    const {
      location,
      location: { timeZone },
      handleSelectSlot,
      selectedSlots,
      shouldSelectFirstSlotAsInitialValue,
    } = this.props;
    const { selectedDate, nextDate } = this.state;

    const isClinicClosed = !dateHasOpenHours(location, selectedDate);
    const todayAndTomorrowSlots = getSlotsForTodayAndTomorrow(this.props.location);
    const todaySlots = removeSlotsBeforeDisableReservationsUntilTimestamp(
      popFirstUnavailableSlots(todayAndTomorrowSlots.today),
      location
    );
    const tomorrowSlots = popFirstUnavailableSlots(todayAndTomorrowSlots.tomorrow);

    let selectedDateSlots = null;
    let nextDateSlots = null;
    let moreDateOverride = false;

    if (isDateToday(selectedDate, location.timeZone)) {
      selectedDateSlots = todaySlots;
      nextDateSlots = tomorrowSlots;
    } else if (isDateTomorrow(selectedDate, location.timeZone)) {
      selectedDate.startOf('day');
      selectedDateSlots = tomorrowSlots;
      nextDateSlots = null;
    } else if (shouldShowFeature(MORE_DATES_SLOT_SELECTOR, location)) {
      const selectedDateSlotData = this.getSlotDataForDate(selectedDate);

      if (selectedDateSlotData && selectedDateSlotData !== 'loading') {
        selectedDateSlots = selectedDateSlotData;
        moreDateOverride = true;
      } else
        return (
          <SlotLoading>
            <Loading color={colors.crunchBerry} />
          </SlotLoading>
        );
    } else {
      selectedDateSlots = generateSlotsFromOperatingHours(selectedDate, location);
      moreDateOverride = true;
    }

    const selectedDateHasNoSlotsLeft =
      !hasSlotsAvailable(selectedDateSlots) ||
      (!moreDateOverride && !isReservationsRemaining(this.props.location, selectedDate));

    if (isClinicClosed) {
      return (
        <ClinicClosed
          selectedDate={selectedDate}
          nextDate={nextDate}
          nextDateSlots={nextDateSlots}
          location={location}
        />
      );
    }

    if (selectedDateHasNoSlotsLeft) {
      return (
        <NoSlotsLeft
          selectedDate={selectedDate}
          nextDateSlots={nextDateSlots}
          nextDate={nextDate}
          location={location}
        />
      );
    }

    return (
      <StyledTimeSlotGrid
        selectedSlots={selectedSlots}
        shouldSelectFirstSlotAsInitialValue={shouldSelectFirstSlotAsInitialValue}
        handleSelectSlot={handleSelectSlot}
        timeZone={timeZone}
        slots={selectedDateSlots}
      />
    );
  };

  getDefaultTabIndex = () => {
    const { location, selectedSlots } = this.props;
    const today = moment.tz(location.timeZone);
    const todayAndTomorrowSlots = getSlotsForTodayAndTomorrow(location);
    const todaySlots = popFirstUnavailableSlots(todayAndTomorrowSlots.today);

    if (!isEmptyArray(selectedSlots)) {
      const firstSelectedSlot = moment.tz(selectedSlots[0].appointmentDate, location.timeZone);
      const tomorrow = today.clone().add(1, 'day');

      if (firstSelectedSlot.isSame(today, 'day')) {
        return 0;
      }

      if (firstSelectedSlot.isSame(tomorrow, 'day')) {
        return 1;
      }

      return 2;
    }

    if (!dateHasOpenHours(location, today) || !hasSlotsAvailable(todaySlots)) {
      return 1;
    }

    return 0;
  };

  setAndHandleDate = state => {
    const { location } = this.props;
    state.selectedDate &&
      isDateAfterTomorrow(state.selectedDate, location.timeZone) &&
      shouldShowFeature(MORE_DATES_SLOT_SELECTOR, location) &&
      this.fetchSlotDataForDate(state.selectedDate);

    this.setState(
      state,
      () => state.selectedDate && this.props.handleSelectedDate(state.selectedDate)
    );
  };

  setSlotDataForDate = (selectedDate, slots, callback) => {
    const { futureSlotData } = this.state;
    this.setState(
      { futureSlotData: { ...futureSlotData, [selectedDate.format('YYYY-MM-DD')]: slots } },
      callback
    );
  };

  getSlotDataForDate = selectedDate => {
    const { futureSlotData } = this.state;
    return selectedDate && futureSlotData[selectedDate.format('YYYY-MM-DD')];
  };

  validateSelectedSlots = () => {
    if (isEmptyArray(this.props.selectedSlots) || isEmptyArray(this.props.location.slots)) {
      return;
    }

    const tomorrow = moment.tz(this.props.location.timeZone).add(1, 'day');

    // Once we're fetching actual availability for beyond tomorrow, we can just check `isSlotAvailable`
    if (
      this.props.selectedSlots.every(
        slot =>
          isSlotAvailable(slot, this.props.location) ||
          moment.tz(slot.appointmentDate, this.props.location.timeZone).isAfter(tomorrow, 'day')
      )
    ) {
      return;
    }

    this.props.handleSelectSlot(EMPTY_ARRAY);
  };

  updateSelectedAndNextDates = () => {
    const { location, selectedSlots } = this.props;
    const today = moment.tz(this.props.location.timeZone);
    const todayAndTomorrowSlots = getSlotsForTodayAndTomorrow(this.props.location);
    const todaySlots = popFirstUnavailableSlots(todayAndTomorrowSlots.today);

    if (!isEmptyArray(selectedSlots)) {
      const firstSelectedSlot = moment.tz(selectedSlots[0].appointmentDate, location.timeZone);

      const tomorrow = moment.tz(this.props.location.timeZone).add(1, 'day');

      const isMoreDate = firstSelectedSlot.isAfter(tomorrow, 'day');

      this.setState({
        selectedDate: firstSelectedSlot,
        nextDate: firstSelectedSlot.clone().add(1, 'day'),
        isMoreDate,
      });
    } else if (!dateHasOpenHours(location, today) || !hasSlotsAvailable(todaySlots)) {
      this.setState({
        selectedDate: moment.tz(this.props.location.timeZone).add(1, 'day'),
        nextDate: moment.tz(this.props.location.timeZone).add(2, 'day'),
      });
    } else {
      this.setState({
        selectedDate: moment.tz(this.props.location.timeZone),
        nextDate: moment.tz(this.props.location.timeZone).add(1, 'day'),
      });
    }
  };

  fetchSlotDataForDate = selectedDate => {
    if (!this.getSlotDataForDate(selectedDate)) {
      this.setSlotDataForDate(selectedDate, 'loading', () =>
        fetchSlotsForDate(this.props.location, selectedDate)
          .then(slots => this.setSlotDataForDate(selectedDate, slots))
          .catch(console.error)
      );
    }
  };

  render() {
    const { selectedDate, nextDate } = this.state;
    if (!this.props.location.hasOwnProperty('slots') || !selectedDate || !nextDate) {
      return (
        <SpacedLoading>
          <Loading color={colors.crunchBerry} />
        </SpacedLoading>
      );
    }

    const {
      location,
      location: { timeZone },
    } = this.props;

    return (
      <div data-testid="booking-time-selector">
        <StyledTabs
          tabs={this.tabs}
          selectedTabIndex={this.getDefaultTabIndex()}
          isCentered
          styledTabs={PlainTabs}
          length={this.tabs.length}
        />
        <Content>
          <Collapse in={this.state.isMoreDate} timeout="auto" mountOnEnter>
            <SolvCalendar
              selectedDate={selectedDate}
              location={location}
              handleDateChange={selectedDate => this.setAndHandleDate({ selectedDate })}
            />
          </Collapse>
          <Day>
            <DateTime dateTime={selectedDate} format={'dddd, MMMM D'} timeZone={timeZone} />
          </Day>
          {this.getContentToRender()}
        </Content>
      </div>
    );
  }
}

TimeSelector.defaultProps = {
  shouldSelectFirstSlotAsInitialValue: true,
};

TimeSelector.propTypes = {
  location: PropTypes.object,
  handleSelectSlot: PropTypes.func,
  handleSlotGridChange: PropTypes.func,
  selectedSlots: PropTypes.arrayOf(SlotShape),
  shouldSelectFirstSlotAsInitialValue: PropTypes.bool,
  fetchLocationSlotsData: PropTypes.func,
  handleSelectedDate: PropTypes.func,
};

export default TimeSelector;
